import styled from 'styled-components'
import { black, textMuted, mutedGrey, white, grey, border1 } from '@/theme/colors'
import { shadows, radii, motion, layers } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'
import { dashedSlot } from '@/theme/recipes'
import { Button } from '@components/Button'

export const SectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

export const SectionLabel = styled.div`
	font-size: ${fontSizes.caption};
	font-weight: 500;
	color: ${textMuted};
	display: flex;
	align-items: center;
	gap: 6px;

	svg {
		width: 14px;
		height: 14px;
		fill: currentColor;
	}
`

export const AddButton = styled(Button).attrs({ variant: 'ghost' as const, size: 'sm' as const })``

export const ThumbnailGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
`

export const ThumbnailItem = styled.div`
	position: relative;
	width: 110px;
	height: 110px;
	border-radius: ${radii.small};
	overflow: hidden;
	border: 1px solid ${border1};
	background: ${grey};
	cursor: pointer;
	transition: transform ${motion.fast}, box-shadow ${motion.fast};

	&:hover {
		transform: translateY(-1px);
		box-shadow: ${shadows.card};
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const ThumbnailDocIcon = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4px;
	color: ${mutedGrey};

	span {
		font-size: ${fontSizes.micro};
		font-weight: 700;
		text-transform: uppercase;
		color: ${textMuted};
		max-width: 100px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
	}
`

export const RemoveButton = styled.button`
	position: absolute;
	top: 4px;
	right: 4px;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background: ${black}a6;
	color: ${white};
	border: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${fontSizes.micro};
	line-height: ${leading.none};
	padding: 0;
	opacity: 0;
	transition: opacity ${motion.fast};
	z-index: ${layers.raised};

	${ThumbnailItem}:hover & {
		opacity: 1;
	}

	&:hover {
		background: ${black}d9;
	}
`

export const UploadingOverlay = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 6px 10px;
	background: ${grey};
	border-radius: ${radii.small};
	font-size: ${fontSizes.micro};
	color: ${textMuted};
`


export const EmptyAttachments = styled.button`
	${dashedSlot}
	font-size: ${fontSizes.micro};
`
